<template>
  <div class="menu-contact">
    <a href="mailto:info@thevisualagency.com">info@thevisualagency.com</a>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.menu-contact {
  .mobile & ,
  .tablet &{
    @include ButtonM;
    text-decoration: none;
    color: $white;
    a {
      color: $white;
    }
  }
  .desktop & {
    @include ButtonS;
    text-decoration: none;
    color: $white-50;
    a {
      color: $white-50;
      &:hover {
        color: $white;
      }
    }
  }
}
</style>